import { BusinessSubscription, SubscriptionPlan } from 'services/@types';

/**
 * Collapses a populated subscriptionPlanId object down to its string ID
 * before sending to the PATCH /businesses/:id endpoint.
 * The API expects an ID string; the GET response may return a full object.
 */
export function normalizeSubscription(
  sub: BusinessSubscription,
): BusinessSubscription {
  const planId = sub.subscriptionPlanId;
  if (planId !== undefined && typeof planId === 'object') {
    return { ...sub, subscriptionPlanId: (planId as SubscriptionPlan).id };
  }
  return sub;
}
